import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import logo from '../assets/images/myMetlife-logo.png';
import Loading from './UI/Loading';

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

const SSLoginForm = ({ loading }) => (
  <div style={{ height: '100%', display: 'flex' }}>
    <div className="card-sso m-auto">
      <img src={logo} alt="logo" className="card-image-sso" />
      {loading ? (
        <Loading />
      ) : (
        <div className="card-content-sso">
          <h2 className="card-title-sso">Invalid Token</h2>
          <p className="card-description-sso">Looks like you have reached a dead end. Check your route again</p>
        </div>
      )}
    </div>
  </div>
);

SSLoginForm.propTypes = {
  loading: PropTypes.bool.isRequired,
};

SSLoginForm.defaultProps = {};

export default withRouter(SSLoginForm);
